const csvEscape = (val) => {
  if (val == null) return "";
  const s = String(val);
  if (/[",\n]/.test(s)) return `"${s.replace(/"/g, '""')}"`;
  return s;
};

export const entriesToCsv = (entries) => {
  const header = ["date", "project", "task", "hours", "notes"];
  const rows = entries.map((e) => [
    e.date,
    e.project,
    e.task,
    Number(e.hours || 0).toFixed(2),
    e.notes || "",
  ]);
  return [header, ...rows].map((r) => r.map(csvEscape).join(",")).join("\n");
};

export const downloadCsv = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
